import {
	Breakpoints,
	BreakpointWrapper,
	DecorativeImage,
	Layout,
	LayoutProps,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const gridDisplay = {
	[Breakpoints.default]: [
		{ name: '.', columns: 2 },
		{ name: 'parallax', columns: 20 },
		{ name: '.', columns: 2 },
	],
};

const ParallaxSectionLayout = styled(Layout)<LayoutProps>`
	//padding: var(--size-dynamic0140) 0;
	background-color: var(--c-white);
	overflow: hidden;

	& #parallax-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		/* background-color: lightblue; */
		position: relative;
		overflow: hidden;
		padding-top: var(--size-dynamic0300);

		&::before {
			content: '';
			background: transparent;
			background: linear-gradient(180deg, var(--c-white) 0%, transparent 100%);
			width: 100%;
			height: 10%;
			position: absolute;
			top: 0;
			z-index: 99;
		}

		&::after {
			content: '';
			background: transparent;
			background: linear-gradient(0deg, var(--c-white) 0%, transparent 100%);
			width: 100%;
			height: 10%;
			position: absolute;
			bottom: 0;
			z-index: 99;
		}
		height: 95vh;
		@media (min-width: 560px) {
			height: 120vh;
		}
	}
`;

const ParallaxImage = styled.div<{ $zIndex: number; $position?: number }>`
	position: absolute;
	top: ${(props) => props.$position}%;
	z-index: ${(props) => props.$zIndex};
	will-change: transform;
	& > img:last-child {
		transform: translateY(-100px);
	}
`;

export const Parallax = (): React.ReactElement => {
	const sectionRef = React.useRef<HTMLDivElement>(null);

	const parallaxImages = [
		{
			layer: 'layer1',
			className: 'parallax-image--layer-1',
			zIndex: 1,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item01?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT03MjEmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJjMwMDY=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item01?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTM4NCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmY2EwYg==',
			},
			position: {
				desktop: 20,
				mobile: 20,
			},
			speed: {
				desktop: 0.7,
				mobile: 0.7,
			},
		},
		{
			layer: 'layer2',
			className: 'parallax-image--layer-2',
			zIndex: 2,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item02?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT02MTQmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJjY2YTU=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item02?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTI2MSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmYzI0OQ==',
			},
			position: {
				desktop: 53,
				mobile: 53,
			},
			speed: {
				desktop: 1.2,
				mobile: 1.3,
			},
		},
		{
			layer: 'layer3',
			className: 'parallax-image--layer-3',
			zIndex: 2,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item03?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT00MjQmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJmI0YWU=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item03?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTE3OCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmMmNlMg==',
			},
			position: {
				desktop: 92,
				mobile: 85,
			},
			speed: {
				desktop: 3,
				mobile: 4,
			},
		},
		{
			layer: 'layer4',
			className: 'parallax-image--layer-4',
			zIndex: 1,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item04?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT01OTMmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJmZmMDM=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item04?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTI4OSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmOWFhNw==',
			},
			position: {
				desktop: 100,
				mobile: 90,
			},
			speed: {
				desktop: 1.4,
				mobile: 1.6,
			},
		},
		{
			layer: 'layer5',
			className: 'parallax-image--layer-5',
			zIndex: 3,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item05?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT0zMzcmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJjdhZTM=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item05?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTIwOCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmZjMzNg==',
			},
			position: {
				desktop: 183,
				mobile: 170,
			},
			speed: {
				desktop: 6,
				mobile: 6,
			},
		},
		{
			layer: 'layer6',
			className: 'parallax-image--layer-6',
			zIndex: 4,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item06?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT02MDImZm10PXBuZy1hbHBoYSZiZmM9b2ZmJmNjYTg=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item06?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTMyNSZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmODQ2Mg==',
			},
			position: {
				desktop: 150,
				mobile: 137,
			},
			speed: {
				desktop: 2.6,
				mobile: 2.1,
			},
		},
		{
			layer: 'layer7',
			className: 'parallax-image--layer-7',
			zIndex: 3,
			image: {
				desktop:
					'https://assets.volkswagen.com/is/image/volkswagenag/parallax_item07?Zml0PWNyb3AlMkMxJndpZD0yNTAzJmhlaT01MTEmZm10PXBuZy1hbHBoYSZiZmM9b2ZmJmVlNzk=',
				mobile:
					'https://assets.volkswagen.com/is/image/volkswagenag/m_parallax_item07?Zml0PWNyb3AlMkMxJndpZD03NTAmaGVpPTI0NCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmNmRmZQ==',
			},
			position: {
				desktop: 140,
				mobile: 130,
			},
			speed: {
				desktop: 1.5,
				mobile: 1.5,
			},
		},
	];

	useGSAP(() => {
		if (!sectionRef.current) return;

		const layers = gsap.utils.toArray<HTMLElement>(sectionRef.current.querySelectorAll('.parallax-layer'));

		layers.forEach((layer) => {
			const speed = parseFloat(layer.dataset.speed || '0');

			gsap.to(layer, {
				yPercent: () => -(200 * speed),
				ease: 'none',
				scrollTrigger: {
					trigger: sectionRef.current,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 1,
				},
			});
		});
	}, []);

	return (
		<ParallaxSectionLayout data-testid="parallax-section" appearance={gridDisplay}>
			<div ref={sectionRef} id="parallax-container">
				{parallaxImages.map((imageItem) => (
					<>
						<BreakpointWrapper max={Breakpoints.b960}>
							<ParallaxImage
								key={imageItem.layer}
								$zIndex={imageItem.zIndex}
								$position={imageItem.position.mobile}
								className={`parallax-layer ${imageItem.className}`}
								data-speed={imageItem.speed.mobile}
							>
								<DecorativeImage src={imageItem.image.mobile} />
							</ParallaxImage>
						</BreakpointWrapper>
						<BreakpointWrapper min={Breakpoints.b960}>
							<ParallaxImage
								key={imageItem.layer}
								$zIndex={imageItem.zIndex}
								$position={imageItem.position.desktop}
								className={`parallax-layer ${imageItem.className}`}
								data-speed={imageItem.speed.desktop}
							>
								<DecorativeImage src={imageItem.image.desktop} />
							</ParallaxImage>
						</BreakpointWrapper>
					</>
				))}
			</div>
		</ParallaxSectionLayout>
	);
};
